import _classCallCheck from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import { blue } from '@material-ui/core/colors';

var styles = function styles(theme) {
  return {
    tab: {
      color: blue[900]
    }
  };
};

var MenuTabs =
/*#__PURE__*/
function (_Component) {
  _inherits(MenuTabs, _Component);

  function MenuTabs() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MenuTabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuTabs)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "link", function (goTo) {
      var history = _this.props.history;
      history.push(goTo);
    });

    return _this;
  }

  _createClass(MenuTabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          menu = _this$props.menu,
          activeItem = _this$props.activeItem;
      return React.createElement(Fragment, null, React.createElement(AppBar, {
        position: "static",
        color: "secondary"
      }, React.createElement(Tabs, {
        value: activeItem // onChange={this.handleChange}
        ,
        indicatorColor: "primary",
        textColor: "inherit",
        variant: "fullWidth",
        className: classes.tabs
      }, Object.keys(menu).map(function (path) {
        return React.createElement(Tab, {
          key: "tab-".concat(path),
          classes: {
            selected: classes.tab
          },
          value: path,
          label: menu[path],
          onClick: function onClick() {
            _this2.link(path);
          }
        });
      }))));
    }
  }]);

  return MenuTabs;
}(Component);

MenuTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  menu: PropTypes.object.isRequired
};
export default withStyles(styles, {
  withTheme: true
})(withRouter(MenuTabs));